export default "__VITE_ASSET__fabd7909__"